import { Grid, Typography } from "@mui/material";
import WarningAmberIcon from "@mui/icons-material/WarningAmber";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";

interface ErrorMessageProps {
  message: string;
  type?: "error" | "warning";
}

function ErrorMessage({ message, type = "error" }: ErrorMessageProps) {
  if (!message) return null;

  const styles =
    type === "error"
      ? {
        backgroundColor: "#fdecea",
        color: "#d32f2f",
      }
      : {
        backgroundColor: "#f5f5f5",
        color: "#757575",
      };

  const Icon = type === "error" ? ErrorOutlineIcon : WarningAmberIcon;

  return (
    <Grid
      container
      alignItems="center"
      spacing={1}
      width={"100%"}
      maxWidth={1230}
      justifyContent={"center"}
      sx={{
        borderRadius: 1,
        p: 1,
        ...styles,
      }}
    >
      <Grid >
        <Icon fontSize="small" />
      </Grid>
      <Grid >
        <Typography variant="body2">{message}</Typography>
      </Grid>
    </Grid>
  );
}

export default ErrorMessage;
